export default __webpack_public_path__ + "static/media/recarga.4b02a58e.png";